import React, { FC } from "react";
import { DRList } from "./list/DRList";
import "../../Components/fileList/fileList.css"
import { lddGlobalSessionInfo } from "../../Components/navigationTypes";
import { useAppSelector } from "../../redux/hooks";
import { launchLDDzoho } from "./drFuncs";
import { FileTabButton } from "../../SideDrawer/fileTabButton";
import { fileTabVal } from "../../SideDrawer/sideTypes";
import { adMapper } from "../../util/rpwConst";

const DRListContainer: FC = ({ }) => {
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    return (
        <div className="dashboard" style={{ flex: 1 }}>
            <div className="dashboard-ad">
                <img 
                    src="./ad_dashboard.png" 
                    onClick={() => launchLDDzoho("https://zfrmz.com/cdIabRvui3fve5FCSqvc", sessionInfo, adMapper.ad_dashboard)}
                    style={{ cursor: "pointer" }}
                    alt="Dashboard Advertisement"
                />
            </div>

            <div className="dashboard-tabs-container">
                <FileTabButton
                    setValue={fileTabVal.EMPTY}
                    setMenuState={() => null}
                    stateValue={fileTabVal.EMPTY}
                    icon={"fa-duotone fa-solid fa-file"}
                    title={"Files"}
                />
                <FileTabButton
                    setValue={fileTabVal.EMPTY}
                    setMenuState={() => null}
                    stateValue={fileTabVal.EMPTY}
                    icon={"fa-duotone fa-solid fa-file"}
                    title={"OREA"}
                    external={{ newTab: true , url: `../docservice/?SessionID=${sessionInfo.sid}`, adImage: "../docservice/logo-orea.png"}}
                />
            </div>

            <DRList />
        </div>
    )
}

export default DRListContainer;